import React, { useEffect, useRef, useState } from 'react';
import ApexCharts from 'apexcharts';
import TauriSectionModalVisual from '../TauriSectionBaseVisual/TauriSectionModalVisual/TauriSectionModalVisual';
import TauriSectionModalMultiVisual from '../TauriSectionBaseVisual/TauriSectionModalMultiVisual/TauriSectionModalMultiVisual';
import setting from '../../config.json';

function formatNumber(num) {
    if (Math.abs(num) >= 1e6) {
        return (num / 1e6).toFixed(2) + 'M'; // Display millions
    } else if (Math.abs(num) >= 1e3) {
        return (num / 1e3).toFixed(2) + 'K'; // Display thousands
    } else {
        return num.toString(); // No suffix for numbers less than 1000
    }
}

const TauriHorizontalBarVisual = ({ chartConfig, chartData, chartOptions, columnSize, rowSize, palettes, themes, chartPalettes }) => {
    const chartRef = useRef(null);
    const [selectedVisual, setSelectedVisual] = useState(null);
    const [selectedData, setSelectedData] = useState(null);
    const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });

    useEffect(() => {
        if (!chartData) return;

        const seriesItem = chartConfig.binding.data.series;
        const series = [{
            name: seriesItem.name,
            data: chartData.map(item => item[seriesItem.value]),
            color: chartPalettes[0].ranges[0],
        }];

        const options = {
            chart: {
                ...chartOptions.chart,
                toolbar: {
                    show: true,
                    tools: {
                        download: true
                    }
                },
            },
            tooltip: chartOptions.tooltip,
            xaxis: {
                ...chartOptions.xaxis,
                categories: chartData.map(item => item[chartConfig.binding.data.title]),
                title: {
                    ...chartOptions.xaxis.title,
                    text: chartConfig.xAxis
                }
            },
            yaxis: {
                ...chartOptions.yaxis,
                title: {
                    ...chartOptions.yaxis.title,
                    text: chartConfig.yAxis
                }
            },
            // colors: series.map(item => item.color),
            series,
            grid: chartOptions.grid,
            legend: chartOptions.legend,
            dataLabels: {
                ...chartOptions.dataLabels,
                formatter: function (val, opts) {
                    const labelText = chartData[opts.dataPointIndex][chartConfig.binding.data.title];
                    const capitalizedLabel = labelText.toUpperCase();
                    const formattedValue = formatNumber(val);
                    return (opts.dataPointIndex + 1) + ' ' + capitalizedLabel + ' (' + formattedValue + ')';
                },
            },
            plotOptions: chartOptions.plotOptions,
            stroke: chartOptions.stroke
        };

        const chart = new ApexCharts(chartRef.current, options);

        chart.render();

        return () => {
            chart.destroy();
        };
    }, [chartConfig, chartData]);

    const handleOnClick = (index) => {
        // const selectedSeries = chartData[index];
        // const selectedId = Object.values(selectedSeries)[0]; //the 0 is the position order of the selected id
        // const selectedDesc = Object.values(selectedSeries)[2]; //the 2 is the position order of the selected item
        // const selectedVal = Object.values(selectedSeries)[3]; //the 3 is the position order of the selected value

        // if (chartConfig.binding.context.point.onClick.visual &&
        //     Array.isArray(chartConfig.binding.context.point.onClick.visual)) {
        //     const selectedVisual = chartConfig.binding.context.point.onClick.visual.find(item => item.id === selectedId);
        //     setSelectedVisual(selectedVisual);
        //     setSelectedData({ selectedId, selectedDesc, selectedVal });

        // let posX = event.clientX;
        //                 let posY = event.clientY;
        //                 if ((event.clientX + setting.modalMinWidth) > window.innerWidth) {
        //                     posX = event.clientX - setting.modalMinWidth;
        //                 }
        //                 if ((event.clientY + setting.modalMinHeight) > window.innerHeight) {
        //                     posY = event.clientY - setting.modalMinHeight;
        //                 }

        //     setModalPosition({ x: posX, y: posY });
        // }
    };

    return (
        <div>
            <div className='chart-content'>
                <div ref={chartRef} />
                <div style={{ position: 'absolute', top: 0, width: '100%', height: '100%' }}>
                    <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', top: '0.8125rem', paddingLeft: '2.1875rem', justifyContent: 'center', width: '100%', height: '100%' }}>
                        {chartData && chartData.map((item, index) => (
                            <div key={index}
                                style={{ marginBottom: '0.625rem', userSelect: 'none', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', cursor: 'pointer' }}
                                onClick={() => handleOnClick(index)}>
                                <span style={{ fontFamily: 'Lato-Bold' }}>{index + 1}</span>
                                {' '}
                                <span style={{ fontFamily: 'Lato-Regular' }}>{item[chartConfig.binding.data.title].toUpperCase()}</span>
                                {' '}
                                <span style={{ fontFamily: 'Lato-Light' }}>{'(' + formatNumber(item[chartConfig.binding.data.series.value]) + ')'}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {selectedVisual && (
                chartConfig.binding.context.point.onClick.visuals ? (
                    <TauriSectionModalMultiVisual
                        show={selectedVisual !== null}
                        onHide={() => setSelectedVisual(null)}
                        selectedData={selectedData}
                        visual={selectedVisual}
                        columnSize={columnSize}
                        rowSize={rowSize}
                        style={{ top: modalPosition.y, left: modalPosition.x }}
                        palettes={palettes}
                        themes={themes}
                    />
                ) : (
                    <TauriSectionModalVisual
                        show={selectedVisual !== null}
                        onHide={() => setSelectedVisual(null)}
                        selectedData={selectedData}
                        visual={selectedVisual}
                        columnSize={columnSize}
                        rowSize={rowSize}
                        style={{ top: modalPosition.y, left: modalPosition.x }}
                        palettes={palettes}
                        themes={themes}
                    />
                )
            )}
        </div>
    );
};

export default TauriHorizontalBarVisual;
